import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=637e2284&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=637e2284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e2284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637e2284')) {
      api.createRecord('637e2284', component.options)
    } else {
      api.reload('637e2284', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=637e2284&scoped=true&", function () {
      api.rerender('637e2284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ra4qKPI393ug/JS/comp/DateRangeExt.vue"
export default component.exports